export default __webpack_public_path__ + "static/media/12-have good luck.adf36ff7.svg";